import GenericRequest, { METHOD_GET } from '../../../webservices/GenericRequest';
import { ApiEndpoints } from '../../../webservices/endpoint';

export class DocumentStateListTask extends GenericRequest {

    constructor() {
        super(METHOD_GET, ApiEndpoints.DOCUMENT_STATES);
    }

    overrideRequest() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/document/list/document-state-list/DocumentStateListTask.js